<template>
    <div class="pageRegisterLink">
        <div class="page-head">
            <div class="jobMain">
                <div class="page-tle"><i class="el-icon-warning-outline iconStyle"></i> 联系方式</div>
                <div class="page-subtle">如有报名相关疑问，请在工作时间内拨打下方服务热线咨询。</div>
            </div>
        </div>
        <div class="page-main">
            <div class="jobMain">
                <div class="reg-notes-wrap">
                    <div class="reg-notes-cards">
                        <div class="reg-hotLine">
                            <div class="reg-hotLine-t">
                                <span class="reg-hotLine-ticon"><i class="el-icon-phone-outline"></i></span>
                                <span class="reg-hotLine-tle">报名热线</span>
                            </div>
                            <div class="reg-hotLine-b">
                                <div class="reg-hotLine-bt">服务专线 / Hotline</div>
                                <div class="reg-hotLine-b-tel">报名咨询电话:0355-5922042</div>
                                <div class="reg-hotLine-b-tel">技术咨询电话:0355-5920818</div>
                            </div>
                            <div class="reg-hotLine-b reg-hotLine-line">
                                <div class="reg-hotLine-bt"><i class="el-icon-time"></i> 工作时间</div>
                                <div class="reg-hotLine-b-time">上午<span class="hotLine-b-r">09:00 - 12:00</span></div>
                                <div class="reg-hotLine-b-time">下午<span class="hotLine-b-r">14:00 - 18:00</span></div>
                            </div>
                        </div>
                        <div class="reg-appDownload">
                            <div class="reg-appDownload-t">
                                <span class="reg-appDownload-ticon"><i class="el-icon-mobile-phone"></i></span>
                                <span class="reg-appDownload-tle">煤婆新消息APP下载</span>
                            </div>
                            <div class="reg-appDownload-sub">可通过煤婆新消息APP接收审核结果</div>
                            <div class="reg-appDownload-body">
                                <img :src="appDownIcon" alt="煤婆新消息APP下载二维码" class="reg-appDownload-qr" />
                                <div class="reg-appDownload-links">
                                    <a
                                        :href="appDownloadUrls.ios"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="reg-appDownload-link"
                                    >苹果下载</a>
                                    <a
                                        :href="appDownloadUrls.android"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="reg-appDownload-link reg-appDownload-link--android"
                                    >安卓下载</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hotLine-tips">
                        <i class="el-icon-warning-outline hotLine-tips-icon"></i>
                        咨询高峰期电话可能占线，建议您错峰拨打。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import appDownIcon from '../assets/images/appDownIcon.png';

export default {
    name: 'PageRegNotes',
    data() {
        return {
            appDownIcon,
            appDownloadUrls: {
                ios: 'https://apps.apple.com/cn/app/%E7%85%A4%E5%A9%86%E6%96%B0%E6%B6%88%E6%81%AF/id1618346446',
                android: 'https://webimg.mp12345.com/download/app/mpnews-release-1.0.apk?v=0.2',
            },
        };
    },
    mounted() {
        document.title = '潞安招聘-报名须知';
    },
}
</script>

<style scoped>
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .page-head{padding: 24px 0; background-color: #fff;}
    .page-tle{font-size: 20px; color: #101828; font-weight: bold; line-height: 30px; padding-left: 36px;}
    .page-subtle{font-size: 14px; color: #6A7282; line-height: 20px; padding: 10px 0 0 36px;}
    .iconStyle{color: #E7000B; font-size: 24px; margin-right: 10px; vertical-align: middle;}
    .page-main{
        padding: 48px 0 80px;
        min-height: calc(100vh - 320px);
        box-sizing: border-box;
    }
    .reg-notes-wrap{
        max-width: 1000px;
        margin: 0 auto;
    }
    .reg-notes-cards{
        display: flex;
        gap: 24px;
        align-items: stretch;
    }
    .reg-hotLine,
    .reg-appDownload{
        flex: 1;
        min-width: 0;
        max-width: 480px;
    }
    .reg-hotLine{
        padding: 36px 40px;
        border-radius: 14px;
        color: #fff;
        background: linear-gradient(135deg, #E7000B 0%, #C10007 100%);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10);
    }
    .reg-hotLine-ticon{
        width: 40px; height: 40px; display: inline-block; text-align: center;
        font-size: 20px; line-height: 40px; margin-right: 10px;
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.20);
        vertical-align: middle;
    }
    .reg-hotLine-tle{color: #FFF; font-size: 20px; font-weight: 500; line-height: 40px; vertical-align: middle;}
    .reg-hotLine-b{padding: 28px 0 8px;}
    .reg-hotLine-bt{color: #FFE2E2; font-size: 12px; line-height: 24px;}
    .reg-hotLine-b-tel{font-size: 28px; font-weight: 500; line-height: 40px; letter-spacing: 1px;}
    .reg-hotLine-line{border-top: 1px solid rgba(255, 255, 255, 0.20); padding-top: 8px;}
    .reg-hotLine-b-time{line-height: 28px; font-size: 14px;}
    .hotLine-b-r{float: right;}
    .reg-appDownload{
        padding: 36px 40px;
        border-radius: 14px;
        border: 1px solid #E5E7EB;
        background: #fff;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10);
        box-sizing: border-box;
    }
    .reg-appDownload-ticon{
        width: 40px; height: 40px; display: inline-block; text-align: center;
        font-size: 20px; line-height: 40px; margin-right: 10px;
        border-radius: 20px;
        background: #FEF2F2;
        color: #E7000B;
        vertical-align: middle;
    }
    .reg-appDownload-tle{color: #101828; font-size: 20px; font-weight: 500; line-height: 40px; vertical-align: middle;}
    .reg-appDownload-sub{
        margin-top: 8px;
        padding-left: 50px;
        color: #6A7282;
        font-size: 13px;
        line-height: 20px;
    }
    .reg-appDownload-body{padding-top: 20px; text-align: center;}
    .reg-appDownload-qr{
        display: block;
        width: 160px;
        height: 160px;
        margin: 0 auto 20px;
        object-fit: contain;
    }
    .reg-appDownload-links{display: flex; flex-direction: column; gap: 12px;}
    .reg-appDownload-link{
        display: block;
        height: 44px;
        line-height: 44px;
        border-radius: 10px;
        text-align: center;
        text-decoration: none;
        font-size: 15px;
        font-weight: 500;
        color: #fff;
        background: linear-gradient(135deg, #E7000B 0%, #C10007 100%);
        transition: opacity 0.2s ease;
    }
    .reg-appDownload-link:hover{opacity: 0.9; color: #fff;}
    .reg-appDownload-link--android{
        color: #E7000B;
        background: #FEF2F2;
        border: 1px solid #FECACA;
    }
    .reg-appDownload-link--android:hover{color: #C10007;}
    @media (max-width: 900px) {
        .reg-notes-cards{flex-direction: column; align-items: center;}
        .reg-hotLine,
        .reg-appDownload{max-width: 480px; width: 100%;}
    }
    .hotLine-tips{
        border-radius: 10px;
        margin-top: 24px;
        padding: 16px 24px 16px 45px;
        position: relative;
        color: #1447E6;
        font-size: 13px;
        line-height: 22px;
        border: 1px solid #DBEAFE;
        background: #EFF6FF;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
    }
    .hotLine-tips-icon{
        width: 16px; height: 16px; display: block; font-size: 16px; color: #1447E6;
        position: absolute; left: 24px; top: 20px;
    }
</style>
